/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Levumihasmerged2Inputs */

const de__field_levumihasmerged2 = /** @type {(inputs: _Field_Levumihasmerged2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEVUMI resultate wurden übertragen`)
};

/**

* @param {_Field_Levumihasmerged2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_levumihasmerged2 = /** @type {((inputs?: _Field_Levumihasmerged2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Levumihasmerged2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_levumihasmerged2(inputs)
});
export { _field_levumihasmerged2 as "_field_levumiHasMerged" }